import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { StickyNote } from './StickyNote';
import { CountdownTimer } from './CountdownTimer';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-white to-brand-pink-50 py-12 md:py-20 overflow-hidden" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-140">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-141">
          <div className="space-y-6" data-id="element-142">
            <div className="flex flex-wrap items-center gap-3" data-id="element-143">
              <div className="inline-flex items-center gap-2 bg-white border border-yellow-200 px-3 py-1.5 rounded-full shadow-sm" data-id="element-144">
                <div className="flex" data-id="element-145">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-146" />)}
                </div>
                <span className="text-sm font-bold text-gray-900" data-id="element-147">
                  +2.000 mujeres ya empezaron
                </span>
              </div>
              <div className="inline-block bg-brand-pink-600 text-white px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-148">
                Wall Pilates · 28 días
              </div>
            </div>

            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight text-gray-900" data-id="element-149">
              <span className="text-brand-pink-600" data-id="element-150">BAJÁ DE PESO</span>,
              TONIFICÁ Y SENTITE INCREÍBLE EN SOLO{' '}
              <span className="text-brand-pink-600" data-id="element-151">28 DÍAS</span> — DESDE CASA
            </h1>

            <p className="text-xl md:text-2xl text-gray-700 font-semibold" data-id="element-152">
              Sin gym. Sin saltos. Sin matarte entrenando.
            </p>

            <div className="space-y-3" data-id="element-153">
              <p className="text-lg text-gray-800 font-medium" data-id="element-154">
                El método simple que ya ayudó a miles de mujeres a transformar
                su cuerpo desde casa.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-155">
                {['Videos demostrativos paso a paso', 'Alimentación simple y rica', 'Sin equipamiento', 'Acceso inmediato'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-156">
                    <div className="flex-shrink-0 w-6 h-6 bg-emerald-500 rounded-full flex items-center justify-center" data-id="element-157">
                      <CheckIcon className="w-4 h-4 text-white" data-id="element-158" />
                    </div>
                    <span className="text-gray-800 font-medium" data-id="element-159">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="pt-2 space-y-3" data-id="element-160">
              <CTAButton size="large" data-id="element-161">QUIERO EMPEZAR AHORA</CTAButton>

              <div className="flex items-start gap-2 bg-emerald-50 border border-emerald-200 rounded-xl px-4 py-3" data-id="element-162">
                <span className="text-xl leading-none" data-id="element-163">🛡️</span>
                <p className="text-sm text-emerald-900 font-medium leading-snug" data-id="element-164">
                  <span className="font-bold" data-id="element-165">Probalo 7 días sin riesgo.</span>{' '}
                  Si no te encanta, te devolvemos el 100% de tu dinero.
                </p>
              </div>

              <div className="flex flex-wrap items-center gap-4 text-xs text-gray-600" data-id="element-166">
                <span className="flex items-center gap-1" data-id="element-167">
                  🔒 Compra segura
                </span>
                <span className="flex items-center gap-1" data-id="element-168">
                  ⚡ Acceso inmediato
                </span>
              </div>
            </div>
          </div>

          <div className="relative" data-id="element-169">
            <div className="relative flex items-center justify-center p-4" data-id="element-170">
              <img src="https://cdn.magicpatterns.com/uploads/jUEkp9AcBEThFUJD4CKtwQ/PORTADA_SHOPPY.png" alt="Programa Wall Pilates + 10 Bonos" className="w-full max-w-lg h-auto drop-shadow-2xl" data-id="element-171" />
            </div>

            <StickyNote color="pink" rotation={1} className="absolute -top-4 -left-4 z-10" data-id="element-172">
              Solo por hoy
            </StickyNote>
            <StickyNote color="yellow" rotation={2} className="absolute top-8 -right-4 z-10" data-id="element-173">
              10 bonos gratis
            </StickyNote>
            <StickyNote color="cream" rotation={3} className="absolute -bottom-4 left-8 z-10" data-id="element-174">
              Sin gym
            </StickyNote>
            <StickyNote color="pink" rotation={4} className="absolute bottom-8 -right-4 z-10" data-id="element-175">
              Videos de demostración
            </StickyNote>
          </div>
        </div>
      </div>

      <div className="mt-12 bg-brand-pink-600 text-white py-6" data-id="element-176">
        <div className="max-w-4xl mx-auto px-4" data-id="element-177">
          <p className="text-center text-lg md:text-xl font-bold mb-4" data-id="element-178">
            ⚠️ HOY TE LLEVÁS TODO + 10 BONOS GRATIS POR SOLO $16.990
          </p>
          <p className="text-center text-sm md:text-base font-semibold mb-4" data-id="element-179">
            ⏳ ESTA OFERTA TERMINA EN
          </p>
          <CountdownTimer data-id="element-180" />
        </div>
      </div>
    </section>;
}